<template>
  <div v-if="auth.user.selectedAccess.roleLevel > 1">
    <app-header
      :title="$store.getters['translations/getLabel']('SUBDISTRIBUTORS')"
    />
    <b-container>
      <SubdistributorList />
    </b-container>
  </div>
</template>

<script>
import $auth from '@/services/auth';
import SubdistributorList from '@/components/SubdistributorList';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    SubdistributorList,
    AppHeader,
  },
  data() {
    return {
      auth: $auth,
    };
  },
  // created() {
  //   this.$store.dispatch('global/getSubdistributorsList');
  // },
};
</script>
